<template>
  <v-container fluid class="white elevation-4 pt-0">
    <main-app-bar :title="$router.currentRoute.meta.title">
    </main-app-bar>
    <div>
      <div class="pt-3">
        <v-sheet height="64">
          <v-toolbar flat color="white" class="px-0">
            <div class="d-flex align-center">
              <v-btn
                fab
                small
                :disabled="!showCalendar || isLoading"
                color="primary"
                @click="calendarNav('prev')"
              >
                <v-icon dark>mdi-chevron-left</v-icon>
              </v-btn>
              <span class="mx-4 font-weight-bold">{{monthTitle}}</span>
              <v-btn
                fab
                small
                :disabled="!showCalendar || isLoading"
                class="mr-5"
                color="primary"
                @click="calendarNav('next')"
              >
                <v-icon dark>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
              <role-colors-legend :roles="$store.getters.getPersonalRotaRoles"></role-colors-legend>
          </v-toolbar>
        </v-sheet>
        <v-row class="fill-height px-4">
          <v-col cols="12" style="position:relative;">
            <v-sheet height="1240">
              <v-calendar
                v-if="showCalendar"
                weekdays="1, 2, 3, 4, 5, 6, 0"
                ref="calendar"
                v-model="start"
                @change="calendarChangeHandler"
                type="month"
                color="primary"
              >
                  <template v-slot:day="{ date, week }">
                      <v-card elevation="0" flat class="caption mt-2" style="width: 100%;"
                              v-if="convertedData[date]" @click.native.prevent.stop="">
                          <div v-for="(clinicData) in convertedData[date][0]" :key="clinicData.id" class="rota-clinic-wrap">
                              <calendar-action-btn
                                  v-for="(item, index) in clinicData.rotaDayData"
                                  :key="item.designator + item.roleId + item.employeeId + index"
                                  :data="item" :designator="item.designator"
                                  :tooltipInfo="[...convertedData[date][0], ...convertedData[date][1]]"
                                  :week="week"
                              />
                          </div>
                          <div v-if="convertedData[date][1].length">
                              <v-menu :close-on-content-click="false" bottom>
                                  <template v-slot:activator="{ on }">
                                      <v-btn
                                          color="primary"
                                          v-on="on"
                                          x-small
                                          class="ml-2"
                                      >
                                          More
                                      </v-btn>
                                  </template>
                                  <div class="white" style="width: 125px;">
                                      <div v-for="(clinicData) in convertedData[date][1]" :key="clinicData.id" class="rota-clinic-wrap mx-0">
                                          <calendar-action-btn
                                              v-for="(item, index) in clinicData.rotaDayData"
                                              :key="item.designator + item.roleId + item.employeeId + index"
                                              :data="item" :designator="item.designator"
                                              :tooltipInfo="[...convertedData[date][0], ...convertedData[date][1]]"
                                              :week="week"
                                          />
                                      </div>
                                  </div>
                              </v-menu>
                          </div>
                      </v-card>
                  </template>
              </v-calendar>
              <div v-else class="mt-10">
                <h2 class="text-center">{{calendarInfoMsg}}</h2>
              </div>
            </v-sheet>
            <overlay-preloader v-if="!isRotaLoadingError" :loading="isLoading" :absolute="true"></overlay-preloader>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>
<script>
  import MainAppBar from '@/components/MainAppBar'
  import OverlayPreloader from '@/components/OverlayPreloader'
  import CalendarActionBtn from './components/CalendarActionBtn'
  import { getMonthName } from '@/common/date'
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'
  import COLORS from '@/constatns/colors'
  import { sortBy } from 'lodash'
  import RoleColorsLegend from '@/views/rota/components/RoleColorsLegend'
  import formatDates from '../../constatns/formatDates'

  const today = moment()
  export default {
    data: () => ({
        COLORS,
      start: today.format(formatDates.defaultDate),
      dateFrom: today.startOf('month').format(formatDates.defaultDate),
      dateTo: today.endOf('month').format(formatDates.defaultDate),
      calendarData: [],
      isLoading: true
    }),
    computed: {
      ...mapGetters([
        'getPersonalRota',
        'isRotaLoadingError',
        'getUserId']),
      currentEmployee () {
        return this.getUserId
      },
      showCalendar () {
        return this.isRotaLoadingError || (this.calendarData.length > 0 && this.currentEmployee)
      },
      monthTitle () {
        return getMonthName(this.dateFrom)
      },
      calendarInfoMsg () {
        if (this.isLoading) {
          return ''
        }
        if (!this.currentEmployee) {
          return 'Choose employee'
        }
        if (this.calendarData.length === 0) {
          return 'No data for current employee'
        }
        return ''
      },
      convertedData () {
          const { dateFrom, dateTo } = this
          const data = this.getPersonalRota({ dateFrom, dateTo }).reduce((acc, item) => {
              item.records.forEach((record) => {
                  record.employeeId = item.employeeId
                  record.employeeName = item.employeeName
                  record.date = item.date.substr(0, 10)
                  record.selected = false
                if (acc[record.date]) {
                    acc[record.date].push(record)
                } else {
                    acc[record.date] = [record]
                }
              })
              return acc
          }, {})
          for (const [key, value] of Object.entries(data)) {
              const uniqClinics = value.reduce((acc, item) => {
                  const clinic = {
                      clinicId: item.clinicId,
                      roleId: item.roleId,
                      status: item.status,
                      clinicTitle: item.clinicTitle,
                      roleTitle: item.roleTitle
                  }
                  if (!acc.find(uniqClinic => uniqClinic.clinicId === clinic.clinicId && uniqClinic.roleId === clinic.roleId && uniqClinic.status === clinic.status)) {
                      acc.push(clinic)
                  }
                  return acc
              }, [])

              data[key] = uniqClinics.reduce((acc, { clinicId, roleId, status, clinicTitle, roleTitle }) => {
                  const rotaDayData = data[key].filter(rotaInfo => rotaInfo.clinicId === clinicId && rotaInfo.roleId === roleId && rotaInfo.status === status)
                  acc.push({
                      id: `${clinicId}-${roleId}-${status}`,
                      clinicTitle,
                      roleTitle,
                      rotaDayData: sortBy(rotaDayData, ['designator'])
                  })
                  return acc
              }, [])
              data[key] = [data[key].slice(0, 3), data[key].slice(3)]
          }

          return data
      }
    },
    methods: {
      ...mapActions(['fetchPersonalRota']),
      calendarNav (action) {
        if (this.isLoading) {
          return false
        }
        this.$refs.calendar[action]()
      },
      calendarChangeHandler (event) {
        this.dateFrom = event.start.date
        this.dateTo = event.end.date
        this.fetchCalendarData()
      },
      async fetchCalendarData () {
        this.isLoading = true
        try {
          this.calendarData = await this.fetchPersonalRota({
            employeeIds: this.currentEmployee,
            from: this.dateFrom,
            to: this.dateTo,
            GroupId: this.$store.getters.getUserActiveGroup
          })
        } catch (e) {
        }
        this.isLoading = false
      }
    },
      watch: {
          activeGroupId () {
              this.fetchAllEmployees()
          }
      },
    async mounted () {
        this.$store.dispatch('cleanPersonalRota')
        await this.$store.dispatch('fetchRoles')
        this.fetchCalendarData()
    },
    components: {
        RoleColorsLegend,
      MainAppBar,
      CalendarActionBtn,
      OverlayPreloader
    }
  }
</script>

<style lang="scss" scoped>
    .rota-clinic-wrap {
        margin-left: 8px;
        margin-right: 8px;
        border-bottom: 1px solid #87b853;
        padding-bottom: 5px;
        margin-bottom: 5px;
        &:last-child {
            border-bottom: none;
            padding-bottom: 0;
            margin-bottom: 0;
        }
    }
</style>
